import React from 'react';

export default {
	'Error.Unknown': 'Nieznany błąd',
	'Error.Unknown.Message': 'Wystąpił błąd.',
	'Error.NotFound': 'Nie znaleziono',
	'Error.NotFound.Message': 'Żądana strona nie została znaleziona.',
	'Error.Forbidden': 'Zabroniony',
	'Error.Forbidden.Message': 'Nie masz uprawnień dostępu do tej strony.',
	'Error.Invalid': 'Nieprawidłowe dane wejściowe',
	'Error.Invalid.Message': 'Nieprawidłowe pola: {{fields}}.',
	'Error.FileSize.Message': 'Plik, który próbujesz przesłać jest za duży.',
	'PTMD Portal': 'PTMD Portal',
	'Login': 'Login',
	'Logout': 'Wyloguj',
	'FileDrop.Release': 'Zwolnij przycisk, aby wybrać plik',
	'FileDrop.Drag': () => <h5>Przeciągnij i upuść plik tutaj<br/> lub </h5>,
	'FileDrop.Select': 'Wybierz plik',
	'GiB': '{{size}} GiB',
	'MiB': '{{size}} MiB',
	'KiB': '{{size}} KiB',
	'bytes': '{{size}} bajty',
	'FileSize.Max': 'Maksymalny rozmiar wysyłanego pliku wynosi {{size}}',
	'Modal.Open': 'Otwarte',
	'Modal.Close': 'Zamknąć',
	'Language': 'Język'
};
